// extracted by mini-css-extract-plugin
export default {"shopServiceDiv":"shopService_shopServiceDiv__G7HpA","shopServiceContainer":"shopService_shopServiceContainer__yRndv","shopServiceSubDiv":"shopService_shopServiceSubDiv__zJpbs"};